var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('l-bg'),_c('l-stripes',{attrs:{"count":0}},[_c('curveElement',{attrs:{"withAuto":false}})],1),_c('l-popupMessage',{attrs:{"items":_vm.messages},on:{"click":function () { return _vm.$emit('nextStep', 2); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }